// @flow

import * as React from 'react';
import Legal from './Legal';
import type { LegalData } from './Legal';
import type { SimpleLink } from './SimpleLinkSection';
import DDLogo from './DDLogo';
import HorizontalLinkSection from './HorizontalLinkSection';
import IcpSection from './Icp';

type Props = {
  legalData: LegalData,
  icpUrl: string,
  recordFilingUrl: string,
  recordFilingIcon: string,
  footerLinks: SimpleLink[],
};

const LogoLegalSection = ({
  legalData,
  icpUrl,
  recordFilingUrl,
  recordFilingIcon,
  footerLinks,
}: Props) => (
  <div>
    <DDLogo />
    <HorizontalLinkSection links={footerLinks} />
    <Legal legalData={legalData} />
    <IcpSection
      icpUrl={icpUrl}
      recordFilingUrl={recordFilingUrl}
      recordFilingIcon={recordFilingIcon}
    />
  </div>
);

export default LogoLegalSection;
